// extracted by mini-css-extract-plugin
export default {"success":"success-module--success--ps3GV","title":"success-module--title--ys9AT","bottomBtn":"success-module--bottomBtn--owQgF"};